// Куски экранов после выката (HQ-883): старая страница просит куски прошлой сборки, их на сервере уже нет — импорт
// падает. Лечит одна перезагрузка (новый index.html → новые куски). Флаг в sessionStorage — версия сборки, для которой
// перезагрузка уже была: второй раз в той же версии не перезагружаем (цикла нет), ошибка идёт к экрану ошибки.
import { APP_VERSION } from '../api/client';

const KEY = 'soccer.chunk_reload';
// Chrome / Android WebView, Safari / iOS, Firefox; ChunkLoadError — имя ошибки сборщиков с webpack-совместимым загрузчиком
const CHUNK_MESSAGE = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i;

/** Ошибка загрузки куска (динамический import), а не ошибка кода экрана. */
export function isChunkError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.name === 'ChunkLoadError' || CHUNK_MESSAGE.test(error.message);
}

/** Перезагрузить страницу, если для этой версии сборки ещё не перезагружали. true — перезагрузка пошла. */
export function reloadOnce(version: string = APP_VERSION): boolean {
  try {
    if (sessionStorage.getItem(KEY) === version) return false;
    sessionStorage.setItem(KEY, version);
  } catch {
    // хранилище недоступно — флаг не запомнить, перезагрузка могла бы зациклиться: сразу экран ошибки
    return false;
  }
  location.reload();
  return true;
}

/** Загрузка куска с одной перезагрузкой: не загрузился — перезагрузка (промис не завершается, экран ждёт её на
 *  скелетоне); повтор в той же версии или другая ошибка — отказ как есть (экран ошибки маршрута). */
export function withChunkReload<T>(load: () => Promise<T>, version?: string): () => Promise<T> {
  return () => load().catch((error: unknown) => {
    if (isChunkError(error) && reloadOnce(version)) return new Promise<T>(() => {});
    throw error;
  });
}
